/**
 * Shared Sound Library Constants
 * Firebase Storage URLs for universal sounds used by all creatures
 * @module services/sound/shared-sounds
 */

/**
 * Firebase Storage URLs for shared sounds
 * These are universal sounds used by all creatures
 */
export const SHARED_SOUND_URLS = {
  /** Plays when any unit spawns */
  spawn: 'gs://drawn-of-war.appspot.com/shared/sounds/spawn.mp3',
  /** Plays when any unit dies */
  death: 'gs://drawn-of-war.appspot.com/shared/sounds/death.mp3',
  /** Fallback for creatures without generated attack sound */
  defaultAttack: 'gs://drawn-of-war.appspot.com/shared/sounds/default-attack.mp3',
  /** Fallback for creatures without generated hit sound */
  defaultHit: 'gs://drawn-of-war.appspot.com/shared/sounds/default-hit.mp3',
} as const;

export type SharedSoundKey = keyof typeof SHARED_SOUND_URLS;
